import React from "react";
import { Card, Spinner } from "react-bootstrap";
import { RiFileCloseFill } from "react-icons/ri";

const NoData = ({
  label,
  loading,
  height = "30vh",
  bg = "bg-white",
  color = "text-primary",
}) => {
  return (
    <Card
      className={` ${bg} d-flex justify-content-center align-items-center border-0`}
      style={{ minHeight: height }}
    >
      <div className="d-flex flex-column justify-content-center align-items-center w-100 gap-10">
        {loading ? (
          <Spinner size="30" className={`${color}`} />
        ) : (
          <>
            <RiFileCloseFill className="text-primary" size={30} />
            <div className="fs-20">
              No {label ? `${label.toLowerCase()}'s` : "data"} available
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

export default NoData;
